import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';

const SelectClass = ({
  classData,
  setClassData,
  courses,
  batchStructures = [],
  fetchBatchStructures,
  fetchBatchesByStructure,
  loadingCourses,
  setDisable,
  clearAttendance,
  loading,
  presetBatches,
}) => {
  const { state } = useContext(AuthContext);

  const [batches, setBatches] = useState([]);

  const handleCourseChange = async (e) => {
    const courseId = e.target.value;

    setClassData({
      courseId,
      batchStructureId: '',
      batchId: '',
    });

    setBatches([]);
    clearAttendance?.();
    setDisable?.(true);

    if (courseId) {
      await fetchBatchStructures(courseId);
    }
  };

  const handleBatchStructureChange = async (e) => {
    const batchStructureId = e.target.value;

    setClassData((prev) => ({
      ...prev,
      batchStructureId,
      batchId: '',
    }));

    setBatches([]);
    setDisable?.(true);

    if (batchStructureId) {
      const fetchedBatches = await fetchBatchesByStructure(batchStructureId);
      setBatches(fetchedBatches || []);
    }
  };

  const handleBatchChange = (e) => {
    const batchId = e.target.value;

    setClassData((prev) => ({
      ...prev,
      batchId,
    }));

    if (batchId) {
      setDisable?.(false);
    }
  };

  useEffect(() => {
    if (presetBatches?.length > 0) {
      setBatches(presetBatches);
    }
  }, [presetBatches]);

  useEffect(() => {
    if (!classData.courseId) {
      setBatches([]);
      setDisable?.(true);
    }
  }, [classData.courseId]);

  return (
    <div className="w-full rounded-lg">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Class Information
        </h4>
      </div>

      <div className="mt-6 flex flex-col gap-6 md:flex-row md:justify-center">
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>
          <select
            value={classData.courseId}
            onChange={handleCourseChange}
            disabled={loading}
            className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm outline-none disabled:opacity-60 dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>
            {loadingCourses ? (
              <option>Loading courses...</option>
            ) : (
              courses.map((course, i) => (
                <option key={course._id} value={course._id}>
                  {i + 1}. {course.courseName}
                </option>
              ))
            )}
          </select>
        </div>

        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch Structure
          </label>
          <select
            value={classData.batchStructureId}
            onChange={handleBatchStructureChange}
            disabled={!classData.courseId || loading}
            className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm outline-none disabled:opacity-60 dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Batch Structure</option>
            {batchStructures.map((structure, i) => (
              <option key={structure._id} value={structure._id}>
                {i + 1}. {structure.structureName || structure.name}
              </option>
            ))}
          </select>
        </div>

        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch
          </label>
          <select
            value={classData.batchId}
            onChange={handleBatchChange}
            disabled={!classData.batchStructureId || loading}
            className="mt-2 w-full cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm outline-none disabled:opacity-60 dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Batch</option>

            {batches.length > 0 ? (
              batches.map((batch) => {
                const times =
                  batch.daySchedules
                    ?.map((ds) => ds.startTime)
                    .filter(Boolean) || [];
                const uniqueTimes = [...new Set(times)];
                const timeDisplay =
                  uniqueTimes.length > 0
                    ? ` at ${uniqueTimes.join(' / ')}`
                    : '';

                return (
                  <option key={batch._id} value={batch._id}>
                    B {batch.batchNumber} – From{' '}
                    {new Date(batch.startDate).toLocaleDateString()} to{' '}
                    {new Date(batch.endDate).toLocaleDateString()}
                    {timeDisplay}
                  </option>
                );
              })
            ) : (
              <option value="">No batches available</option>
            )}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SelectClass;
